export class FeedbackDashboard {
    feedbackDashboardHeaderData: FeedbackDashboardItem[];
    feedbackDashboardItemData: FeedbackDashboardItem[];

    constructor() {}
}

export class FeedbackDashboardItem
{
    dashboardOrder: number;
    dashboardHeader: string;
    dashboardScorePercentage: number;
    dashboardScoreSubText: string;
    dashboardScoreMovementPositive: boolean;
    dashboardScoreMovementText: string;
    showDashboardTimeSeries: boolean;
    showDashboardSubScores: boolean;
    feedbackQuestionScoreList: FeedbackQuestionScores[];
    feedbackTimeSeriesData: FeedbackTimeSeries;
    feedbackAdditionalQuestionScoreData: FeedbackAdditionalQuestionScore[];

    constructor() {}
}

export class FeedbackQuestionScores
{
    questionScoreOrder: number;
    questionScoreHeaderText: string;
    questionScoreValueText: string;
    questionScorePercentage: number;

    constructor() {}
}

export class FeedbackTimeSeries
{
    feedbackDataPoints: FeedbackDataPoint[];

    constructor() {}
}

export class FeedbackAdditionalQuestionScore
{
    additionalQuestionScoreOrder: number;
    questionScoreHeaderText: string;
    feedbackDataPoints: FeedbackDataPoint[];

    constructor() {}
}

export class FeedbackDataPoint
{
    dataPointOrder: number;
    label: string;
    value: number;

    constructor() {}
}